import React from "react";
import Select from "react-select";
const LisVocabularyToolbar = ({
  t,
  vocabularies,
  selectedVocabulary,
  onChangeSelectedVocabulary,
  onImportExcel,
  onExportExcel,
  loading,
  isEditing,
}) => {
  const controlHeight = 42;
  const options = Object.keys(vocabularies).map((key) => ({
    value: key,
    label: t(vocabularies[key].displayNameKey, { ns: "lisLabels" }),
  }));

  const selectedOption =
    options.find((option) => option.value === selectedVocabulary) || null;
  const disableActions = loading || isEditing;

  return (
    <div className="d-flex flex-column w-100">
      <label className="mb-2">
        {t("selectVocabularyToEdit", { ns: "lisLabels" })}
      </label>
      <div className="d-flex flex-wrap align-items-center gap-3">
        <div
          style={{
            minWidth: "260px",
            maxWidth: "100%",
            flex: "1 1 320px",
          }}
        >
          <Select
            options={options}
            value={selectedOption}
            onChange={(option) =>
              onChangeSelectedVocabulary(option?.value || null)
            }
            isDisabled={disableActions}
            classNamePrefix="select"
            menuPlacement="auto"
            menuPosition="fixed"
            menuPortalTarget={document.body}
            styles={{
              control: (base, state) => ({
                ...base,
                minHeight: `${controlHeight}px`,
                height: `${controlHeight}px`,
                borderColor: state.isFocused ? base.borderColor : base.borderColor,
              }),
              valueContainer: (base) => ({
                ...base,
                height: "100%",
                padding: "0 8px",
                display: "flex",
                alignItems: "center",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 2000,
              }),
              menu: (base) => ({
                ...base,
                zIndex: 2000,
                overflowY: "auto",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: "100%",
              }),
            }}
          />
        </div>
        <div className="btn-group gap-2  " role="group">
  <button
    className="btn btn-outline-success "
    style={{ height: `${controlHeight}px` }}
    onClick={onImportExcel}
    disabled={disableActions}
    title={t("replaceVocabulary", { ns: "lisLabels" })}
  >
    
    <i className="fas fa-file-excel me-1"></i>
   
    <span>{t("replaceVocabulary", { ns: "lisLabels" })}</span> 
  </button>
  <button
    className="btn btn-outline-info "
    style={{ height: `${controlHeight}px` }}
    onClick={onExportExcel}
    disabled={disableActions}
    title={t("saveVocabulary", { ns: "lisLabels" })}
  >
    
    <i className="fas fa-file-download me-1"></i>
    
    <span>{t("saveVocabulary", { ns: "lisLabels" })}</span>
  </button>
</div>
      </div>
    </div>
  );
};

export default LisVocabularyToolbar;
